import { SensorNormalization } from '../models/sensorNormalization'

export interface SensorNormalizationStateType {
  sensorNormalizations: SensorNormalization[]
  sensorNormalization: SensorNormalization | null
}

const SensorNormalizationState: () => SensorNormalizationStateType = () => ({
  sensorNormalizations: [],
  sensorNormalization: null,
})

export default SensorNormalizationState
